import { IHttpClient } from "../IHttpClient";
import IReleaseNotesService from "./IReleaseNotesService";
import { ReleaseNotesModel } from "../../apiModels/Versioning/ReleaseNote";
import { CurrentVersionModel } from "../../apiModels/Versioning/CurrentVersion";

export class ReleaseNotesService implements IReleaseNotesService {
    private readonly httpclient: IHttpClient;

    constructor(httpclient: IHttpClient) {
        this.httpclient = httpclient;
    }

    private get(url: string): Promise<any> {
        return this.httpclient.get(url).catch((err) => console.error("GET", err))
    }

    getReleaseNotes(page: number, pageSize: number): Promise<ReleaseNotesModel> {
        return new Promise((resolve, reject) => {
            this.get(`v1/releasenotes?pageSize=${pageSize}&page=${page}`)
                .then((response: { data: ReleaseNotesModel; }) => {
                    resolve(response.data);
                })
                .catch((err: any) => {
                    reject(err);
                })
        })
    }
    
    getCurrentVersion(): Promise<string|null> {
        return new Promise((resolve, reject) => {
            this.get(`v1/releasenotes/currentversion`)
                .then((response: { data: CurrentVersionModel }) => {
                    resolve(response?.data?.version ?? null);
                })
                .catch((err: any) => {
                    reject(err);
                })
        })
    }
}